import React, {useState} from 'react';
import {Spinner} from "./Spinner";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

export default function ButtonAction({
  className,
  onClick,
  successMessage,
  errorMessage,
  children
}) {

  const STATUS = {
    SUCCESS: "SUCCESS",
    ERROR: "ERROR"
  }

  const [loading, setLoading] = useState(false)
  const [actionStatus, setActionStatus] = useState(undefined)

  const handleOnClick = () => {
    setLoading(true)
    setActionStatus(undefined)

    onClick().then(r => {
      setLoading(false)
      setActionStatus(STATUS.SUCCESS)
    }).catch(e => {
      console.error(e)

      setLoading(false)
      setActionStatus(STATUS.ERROR)
    })

  }

  return (
    <div className={"bn-booknow-action-button"}>
      {loading && <div className={"bn-booknow-action-progress-container"}>
        <Spinner size={'24px'}/></div>}
      {!loading && !actionStatus &&
        <button className={className}
                onClick={handleOnClick}>
          {children}
        </button>}
      {actionStatus === STATUS.SUCCESS &&
        <div
          className={"bn-booknow-button bn-secondary-button bn-action-button-status"}>
          <FontAwesomeIcon
            icon="fa-solid fa-check"/> {successMessage}</div>}
      {actionStatus === STATUS.ERROR &&
        <div
          className={"bn-booknow-button bn-secondary-button bn-action-button-status"}>
          <FontAwesomeIcon
            icon="fa-solid fa-circle-exclamation"/>{errorMessage}</div>}
    </div>
  )
}